import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useWorkspace } from '../context/WorkspaceContext';
import CompanyList from '../components/CompanyList';
import CompanyDetail from '../components/CompanyDetail';
import AddCompanyModal from '../components/AddCompanyModal';
import API_BASE from '../config/api';

export default function Clients() {
  const { token } = useAuth();
  const { activeWorkspace } = useWorkspace();
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  useEffect(() => {
    if (!activeWorkspace) { setIsLoading(false); return; }
    setIsLoading(true);
    axios
      .get(`${API_BASE}/api/companies`, {
        params: { workspace_id: activeWorkspace._id, type: 'client' },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => { setCompanies(res.data); setIsLoading(false); })
      .catch(() => setIsLoading(false));
  }, [activeWorkspace, token]);

  const filtered = companies.filter((c) =>
    c.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  async function handleAdded(newCompany) {
    try {
      const res = await axios.get(`${API_BASE}/api/companies`, {
        params: { workspace_id: activeWorkspace._id, type: 'client' },
        headers: { Authorization: `Bearer ${token}` },
      });
      const refreshed = res.data.filter((c) => c.is_client);
      setCompanies(refreshed);
      setSelectedCompany(refreshed.find((c) => c._id === newCompany._id) || null);
    } catch {
      setCompanies((prev) => [...prev, newCompany].sort((a, b) => a.name.localeCompare(b.name)));
      setSelectedCompany(newCompany);
    }
  }

  if (!activeWorkspace) {
    return (
      <div style={{ backgroundColor: '#222222', minHeight: 'calc(100vh - 56px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 300, fontSize: '16px', color: '#565656' }}>
          Select a workspace to view clients
        </span>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 56px)', marginTop: '56px', backgroundColor: '#222222' }}>
      <CompanyList
        type="client"
        companies={filtered}
        selectedId={selectedCompany?._id}
        onSelect={setSelectedCompany}
        onAdd={() => setShowAddModal(true)}
        isLoading={isLoading}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />
      <CompanyDetail
        company={selectedCompany}
        type="client"
        onUpdate={(updated) => setCompanies((prev) => prev.map((c) => c._id === updated._id ? updated : c))}
      />
      <AddCompanyModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={handleAdded}
        type="client"
      />
    </div>
  );
}
